/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

// The API documentation lists this route but not its body, so the shape below
// is a guess: one entry per question, marks awarded. Everything that depends on
// that guess lives in `buildGradePayload` — swap that one function when the
// real contract is known and the page needs no other change.

export interface IFRSQuestionGrade {
  ifrsQuestionId: string;
  marks: number;
}

export const buildGradePayload = (grades: IFRSQuestionGrade[]): any => ({
  grades,
});

type GradeIFRSAttemptAPIResponse = {
  error?: ApiError | null;
  data?: any;
};

export const GradeIFRSAttempt = async (
  studentToIfrsId: string,
  grades: IFRSQuestionGrade[]
): Promise<GradeIFRSAttemptAPIResponse> => {
  try {
    const response = await axios.post(
      `/ifrs/student/${studentToIfrsId}/grade`,
      buildGradePayload(grades)
    );
    return { data: response.data?.data ?? response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      // Validation failures come back as a list of messages, not a string.
      const raw = error.response.data?.message;
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: Array.isArray(raw) ? raw.join(", ") : raw,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
